// services/raspberry.js
import axiosInstance from './axiosInstance';

const RASPBERRY_API_URL = '/raspberry';

const raspberryService = {
  async getById(idraspberry) {
    try {
      const response = await axiosInstance.get(`${RASPBERRY_API_URL}/getById.php?idraspberry=${idraspberry}`);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter raspberry por ID:', error);
      return {};
    }
  }
};

export default raspberryService;
